<template>
  <el-dialog
    title="跳转配置"
    :visible.sync="show"
    width="900px"
    class="link-config-dialog"
    :before-close="cancelFun"
  >
    <div class="dialog-content">
      <div class="content-wrapper">
        <div class="left-menu">
          <el-menu :default-active="defaultActive" :default-openeds="opends" class="el-menu-vertical-demo">
            <el-submenu :index="item.id + ''" v-for="(item, i) in leftList" :key="i">
              <span slot="title">{{ item.pageName }}</span>
              <el-menu-item :index="sub.id + ''" v-for="(sub, index) in item.children" :key="index" @click="clickPageName(sub)">
                {{ sub.pageName }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
        <div class="divider-line"></div>
        <div class="right-content">
          <div v-if="!dsCode" class="page-select">
            <el-radio-group v-model="rightPageId" class="page-radio-group">
              <el-radio v-for="(item, i) in currentPage.children" :key="i" :label="item.id" class="page-radio">
                {{ item.pageName }}
              </el-radio>
            </el-radio-group>
          </div>
          <!-- 商品列表 -->
          <div v-if="dsCode == 'goodsList'" class="goods-list">
            <div class="search-area">
              <el-input 
                v-model="goodsSearchData.id" 
                placeholder="请输入商品ID" 
                size="small"
                style="width: 220px"
                class="search-input"
              ></el-input>
              <el-button 
                type="primary" 
                size="small" 
                @click="searchGoodsList"
                class="search-btn"
              >
                搜索
              </el-button>
              <el-button 
                type="info" 
                size="small" 
                @click="resetGoodsList"
                class="reset-btn"
              >
                重置
              </el-button>
            </div>
            <el-table :data="goodsList" class="goods-table">
              <el-table-column prop="" label="" width="80" align="center">
                <template slot-scope="{ row }">
                  <el-radio v-model="pageQueryId" :label="row.id"></el-radio>
                </template>
              </el-table-column>
              <el-table-column prop="id" label="商品ID" min-width="100">
                <template slot-scope="{ row }">
                  <span class="table-cell-text">{{ row.id || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="goodsTitle" label="商品名称" min-width="150">
                <template slot-scope="{ row }">
                  <span class="table-cell-text">{{ row.goodsTitle || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="day" label="封面图" min-width="120" align="center" fixed="right">
                <template slot-scope="{ row }">
                  <el-image
                    v-if="row.coverImageUrl"
                    class="cover-image"
                    :src="row.coverImageUrl"
                    :preview-src-list="[row.coverImageUrl]"
                    fit="cover"
                  ></el-image>
                  <span v-else class="table-cell-text">-</span>
                </template>
              </el-table-column>
            </el-table>
            <pagination
              :total="goodsTotal"
              :page.sync="goodsSearchData.page"
              :limit.sync="goodsSearchData.pageSize"
              @pagination="getGoodsList"
            />
          </div>
          <!-- 商品分类 -->
          <div v-if="dsCode == 'goodsCategoryList'" class="goods-category">
            <el-table
              :data="goodsCategoryList"
              row-key="id"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
              :indent="30"
              default-expand-all
              class="category-table"
            >
              <el-table-column label="" align="left" min-width="80px">
                <template slot-scope="{ row }">
                  <el-radio v-model="pageQueryId" :label="row.id"></el-radio>
                </template>
              </el-table-column>
              <el-table-column label="分类ID" align="left" min-width="100px">
                <template slot-scope="{ row }">
                  <span class="table-cell-text">{{ row.id || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="商品分类" align="left" min-width="150px">
                <template slot-scope="{ row }">
                  <span class="table-cell-text">{{ row.categoryName || '-' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="dsCode == 'customizeLink'" class="custom-link">
            <div class="custom-link-title">输入自定义链接：</div>
            <el-input
              placeholder="请输入自定义链接"
              v-model="customLink"
              class="custom-link-input"
            ></el-input>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" size="small" @click="cancelFun" class="cancel-btn">取 消</el-button>
      <el-button type="primary" size="small" @click="submit" class="submit-btn">保存配置</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getConfigListAPI, getGoodsListAPI, getGoodsCategoryTreeAPI, submitConfigListAPI } from './api'
export default {
  name: 'AdLinkConfig',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      leftList: [],
      adId: '',
      pageId: '',
      rightPageId: '',
      dsCode: '',
      currentPage: {},
      opends: [],
      defaultActive: '',
      goodsSearchData: {
        page: 1,
        pageSize: 10,
        id: '',
        status: 1,
      },
      goodsList: [],
      goodsTotal: 0,
      pageQueryId: '',
      goodsCategoryList: [],
      customLink:''
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.getConfigList();
  },

  methods: {
    submit() {
      let data = {
        id: this.rowId,
        linkConfig: {
          dsCode: this.dsCode,
          pageId: this.dsCode ? this.pageId : this.rightPageId,
          pageQueryId: this.dsCode ? this.pageQueryId : '',
          pagePath: this.dsCode ? this.customLink : '',
        }
      }
      console.log(data)
      submitConfigListAPI(data).then(() => {
        this.$message.success('保存成功')
        this.$emit("closeDialog",true);
      })
    },
    clickPageName(sub) {
      if (this.pageId == sub.id) return
      this.pageQueryId = ''
      this.rightPageId = ''
      this.pageId = sub.id
      this.dsCode = sub.dsCode
      this.currentPage = sub
      if (this.dsCode == 'goodsList') {
        this.getGoodsList()
      }
      if (this.dsCode == 'goodsCategoryList') {
        this.getGoodsCategoryTree()
      }
    },
    async getConfigList() {
      const res = await getConfigListAPI(this.rowId)
      this.leftList = res.linkPageList
      this.opends = this.flattenTree(this.leftList).map(item => String(item.id))
      if (res.linkConfig) {
        const { pageId, pageQueryId, pagePath, dsCode } = res.linkConfig
        this.dsCode = dsCode
        if (dsCode) {
          // 商品   分类
          if (dsCode == 'goodsCategoryList') {
            await this.getGoodsCategoryTree()
          } else if (dsCode == 'goodsList') {
            await this.getGoodsList()
          } else if (dsCode == 'customizeLink') {
            this.customLink = pagePath
          }
          this.pageId = pageId
          this.defaultActive = pageId + ''
          this.pageQueryId = pageQueryId
        } else {
          //商城链接
          const parentId = this.findElementById(this.leftList, pageId).parentId
          this.currentPage = this.findElementById(this.leftList, parentId)
          this.pageId = parentId
          this.rightPageId = pageId
          this.defaultActive = parentId + ''
        }
      }
    },
    flattenTree(tree) {
      let flattenedArray = []
      tree.forEach(node => {
        flattenedArray.push(node)
        if (node.children && node.children.length > 0) {
          flattenedArray = flattenedArray.concat(this.flattenTree(node.children))
        }
      })
      return flattenedArray
    },
    async getGoodsList() {
      const res = await getGoodsListAPI(this.goodsSearchData)
      this.goodsList = res.list
      this.goodsTotal = res.total
    },
    searchGoodsList() {
      this.goodsSearchData.page = 1
      this.getGoodsList()
    },
    resetGoodsList() {
      this.goodsSearchData = {
        page: 1,
        pageSize: 10,
        id: '',
        status: 1,
      }
      this.getGoodsList()
    },
    async getGoodsCategoryTree() {
      this.goodsCategoryList = await getGoodsCategoryTreeAPI({status: 1})
    },
    // 修改第一列无children的样式
    changeTr({ row, column, rowIndex, columnIndex }) {
      if (!row.children && columnIndex == 0) {
        return { paddingLeft: '23px' }
      }
    },
    findElementById(tree, targetId) {
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.id === targetId) {
          return node
        }
        if (node.children && node.children.length > 0) {
          const found = this.findElementById(node.children, targetId)
          if (found) {
            return found
          }
        }
      }
      return null
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>
<style lang="scss" scoped>
// 对话框样式
::v-deep .link-config-dialog {
  .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15), 0 4px 16px rgba(0, 0, 0, 0.1);
    
    .el-dialog__header {
      padding: 24px 28px;
      background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
      border-bottom: 2px solid #f0f2f5;
      
      .el-dialog__title {
        font-size: 20px;
        font-weight: 700;
        color: #1a1e25;
        display: flex;
        align-items: center;
        gap: 8px;
        
        &::before {
          content: '';
          width: 4px;
          height: 20px;
          background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
          border-radius: 2px;
        }
      }
      
      .el-dialog__headerbtn {
        top: 24px;
        right: 28px;
        
        .el-dialog__close {
          font-size: 20px;
          color: #909399;
          transition: all 0.3s ease;
          
          &:hover {
            color: #409EFF;
            transform: rotate(90deg);
          }
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
      background: #ffffff;
    }
    
    .el-dialog__footer {
      padding: 20px 28px;
      background: linear-gradient(135deg, #fafbfc 0%, #f5f7fa 100%);
      border-top: 2px solid #f0f2f5;
    }
  }
}

.dialog-content {
  padding: 24px 28px;
  max-height: 70vh;
  overflow-y: auto;
  
  // 自定义滚动条
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f5f7fa;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c0c4cc;
    border-radius: 3px;
    
    &:hover {
      background: #909399;
    }
  }
}

.content-wrapper {
  display: flex;
  gap: 20px;
  
  .left-menu {
    width: 220px;
    flex-shrink: 0;
    
    ::v-deep .el-menu {
      border: none;
      border-radius: 12px;
      background: #fafbfc;
      padding: 8px 0;
      
      .el-submenu {
        .el-submenu__title {
          font-weight: 600;
          color: #303133;
          padding: 12px 20px;
          transition: all 0.3s ease;
          
          &:hover {
            background: rgba(64, 158, 255, 0.08);
            color: #409EFF;
          }
        }
        
        .el-menu {
          background: #ffffff;
          
          .el-menu-item {
            padding: 10px 20px 10px 40px;
            color: #606266;
            transition: all 0.3s ease;
            
            &:hover {
              background: rgba(64, 158, 255, 0.08);
              color: #409EFF;
            }
            
            &.is-active {
              background: linear-gradient(90deg, rgba(64, 158, 255, 0.1) 0%, rgba(102, 177, 255, 0.05) 100%);
              color: #409EFF;
              font-weight: 600;
              border-right: 3px solid #409EFF;
            }
          }
        }
      }
    }
  }
  
  .divider-line {
    width: 1px;
    background: linear-gradient(180deg, transparent 0%, #e4e7ed 20%, #e4e7ed 80%, transparent 100%);
    flex-shrink: 0;
  }
  
  .right-content {
    flex: 1;
    min-width: 0;
    
    .page-select {
      padding: 20px;
      background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
      border-radius: 12px;
      border: 1px solid #e4e7ed;
      
      .page-radio-group {
        display: flex;
        flex-direction: column;
        gap: 12px;
        
        .page-radio {
          padding: 10px 16px;
          border-radius: 8px;
          border: 1.5px solid #E4E7ED;
          background: #ffffff;
          transition: all 0.3s ease;
          
          ::v-deep .el-radio__input.is-checked .el-radio__inner {
            background-color: #409EFF;
            border-color: #409EFF;
          }
          
          ::v-deep .el-radio__input.is-checked + .el-radio__label {
            color: #409EFF;
            font-weight: 600;
          }
          
          &:hover {
            border-color: #C0C4CC;
            background: #fafbfc;
          }
        }
      }
    }
    
    .goods-list {
      .search-area {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 20px;
        padding: 16px;
        background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
        border-radius: 12px;
        border: 1px solid #e4e7ed;
        
        .search-input {
          flex: 1;
          max-width: 300px;
          
          ::v-deep .el-input__inner {
            border-radius: 10px;
            height: 38px;
            line-height: 38px;
            border: 1.5px solid #E4E7ED;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            background: #ffffff;
            font-size: 13px;

            &:hover {
              border-color: #C0C4CC;
            }
          }
          
          ::v-deep .el-input__inner:focus {
            border-color: #409EFF;
            box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
          }
        }
        
        .search-btn {
          border-radius: 10px;
          padding: 10px 20px;
          font-weight: 600;
          font-size: 13px;
          background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
          border: none;
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          &:hover {
            transform: translateY(-2px);
            background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
            box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);
          }
        }

        .reset-btn {
          border-radius: 10px;
          padding: 10px 20px;
          font-weight: 600;
          font-size: 13px;
          background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
          border: none;
          box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

          &:hover {
            background: linear-gradient(135deg, #909399 0%, #82848a 100%);
            box-shadow: 0 4px 12px rgba(144, 147, 153, 0.35);
            transform: translateY(-2px);
          }
        }
      }
      
      .goods-table {
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid #EBEEF5;
        margin-bottom: 20px;
        
        ::v-deep .el-table__header-wrapper {
          th {
            background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
            color: #303133;
            font-weight: 700;
            padding: 18px 0;
            border-bottom: 2px solid #E4E7ED;
            letter-spacing: 0.3px;
            text-transform: uppercase;
            font-size: 12px;
          }
        }
        
        ::v-deep .el-table__body-wrapper {
          tbody {
            tr {
              transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
              border-bottom: 1px solid #F0F2F5;

              &:hover > td {
                background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
              }
              
              td {
                padding: 18px 0;
                
                .table-cell-text {
                  color: #606266;
                  font-size: 13px;
                  line-height: 1.8;
                  font-weight: 400;
                }
                
                .cover-image {
                  width: 60px;
                  height: 60px;
                  border-radius: 8px;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                  transition: all 0.3s ease;
                  cursor: pointer;
                  
                  &:hover {
                    transform: scale(1.05);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                  }
                }
              }
            }
          }
        }
      }
      
      ::v-deep .pagination {
        margin-top: 20px;
        padding: 20px 0 0;
        border-top: 2px solid #F0F2F5;
        
        .el-pagination {
          .el-pagination__total {
            color: #606266;
            font-weight: 500;
          }
          
          .btn-prev,
          .btn-next {
            border-radius: 6px;
            transition: all 0.3s ease;
            
            &:hover {
              background: #F5F7FA;
              color: #409EFF;
            }
          }
          
          .el-pager li {
            border-radius: 6px;
            transition: all 0.3s ease;
            
            &:hover {
              color: #409EFF;
              background: #F5F7FA;
            }
            
            &.active {
              background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
              color: #ffffff;
              font-weight: 600;
              box-shadow: 0 2px 6px rgba(64, 158, 255, 0.3);
            }
          }
        }
      }
    }
    
    .goods-category {
      .category-table {
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid #EBEEF5;
        
        ::v-deep .el-table__header-wrapper {
          th {
            background: linear-gradient(180deg, #F8FAFF 0%, #F0F4FF 100%);
            color: #303133;
            font-weight: 700;
            padding: 18px 0;
            border-bottom: 2px solid #E4E7ED;
            letter-spacing: 0.3px;
            text-transform: uppercase;
            font-size: 12px;
          }
        }
        
        ::v-deep .el-table__body-wrapper {
          tbody {
            tr {
              transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
              border-bottom: 1px solid #F0F2F5;

              &:hover > td {
                background: linear-gradient(90deg, #F5F7FA 0%, #FAFBFC 100%) !important;
              }
              
              td {
                padding: 18px 0;
                
                .table-cell-text {
                  color: #606266;
                  font-size: 13px;
                  line-height: 1.8;
                  font-weight: 400;
                }
              }
            }
          }
        }
      }
    }
    
    .custom-link {
      padding: 20px;
      background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
      border-radius: 12px;
      border: 1px solid #e4e7ed;
      
      .custom-link-title {
        height: 40px;
        line-height: 40px;
        margin-bottom: 16px;
        font-weight: 600;
        font-size: 15px;
        color: #303133;
      }
      
      .custom-link-input {
        ::v-deep .el-input__inner {
          border-radius: 10px;
          height: 42px;
          line-height: 42px;
          border: 1.5px solid #E4E7ED;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          background: #ffffff;
          font-size: 14px;
          padding-left: 15px;

          &:hover {
            border-color: #C0C4CC;
          }
        }
        
        ::v-deep .el-input__inner:focus {
          border-color: #409EFF;
          box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.15);
        }
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  
  .cancel-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #a4a9b0 0%, #909399 100%);
    border: none;
    box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #909399 0%, #82848a 100%);
      box-shadow: 0 4px 12px rgba(144, 147, 153, 0.35);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(144, 147, 153, 0.25);
    }
  }
  
  .submit-btn {
    border-radius: 10px;
    padding: 10px 24px;
    font-weight: 600;
    font-size: 13px;
    background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
    border: none;
    box-shadow: 0 4px 14px rgba(64, 158, 255, 0.35), 0 2px 6px rgba(64, 158, 255, 0.2);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    letter-spacing: 0.3px;

    &:hover {
      background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
      box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .content-wrapper {
    flex-direction: column;
    
    .left-menu {
      width: 100%;
    }
    
    .divider-line {
      width: 100%;
      height: 1px;
      margin: 20px 0;
    }
  }
}

@media (max-width: 768px) {
  ::v-deep .link-config-dialog {
    .el-dialog {
      width: 95% !important;
      margin: 5vh auto;
    }
    
    .el-dialog__header {
      padding: 16px 20px;
    }
    
    .el-dialog__footer {
      padding: 16px 20px;
    }
  }
  
  .dialog-content {
    padding: 16px 20px;
  }
  
  .content-wrapper {
    .right-content {
      .goods-list {
        .search-area {
          flex-direction: column;
          align-items: stretch;
          
          .search-input {
            max-width: 100%;
          }
        }
      }
    }
  }
}
</style>
